module.exports = __webpack_public_path__ + "nc_static/media/download-csr.286a5f34.svg";